class IzzCustomizer extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.editKey = new URL(location.href).searchParams.get('edit_item');
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
    this.form = this.querySelector('form');
    this.options = [...this.querySelectorAll('[data-option]')];
    this.variantInput = this.querySelector('[data-variant]');
    this.qty = this.querySelector('[data-quantity]');
    this.file = this.querySelector('[data-artwork]');
    this.backFile = this.querySelector('[data-back-artwork]');
    this.backLink = this.querySelector('[data-back-link]');
    this.reuseArtwork = this.querySelector('[data-reuse-artwork]');
    this.quoteArtwork = {};
    this.reuseArtwork?.addEventListener('change', () => { this.updateBackArtwork(); this.preview(); });
    this.backLink?.addEventListener('input', () => { this.backFile.setCustomValidity(''); this.updateQuote(); });
    this.link = this.querySelector('[data-artwork-link]');
    this.clearArtwork = this.querySelector('[data-clear-artwork]');
    this.clearArtwork?.addEventListener('click', () => {
      [this.file, this.backFile, this.sideFile].filter(Boolean).forEach(input => { input.value = ''; input.setCustomValidity(''); });
      this.blankPreview = true;
      [this.link, this.backLink, this.sideLink].filter(Boolean).forEach(input => { input.value = ''; });
      this.placements = {};
      this.quoteArtwork = {};
      if (this.quotePanel) this.quotePanel.hidden = true;
      this.error.textContent = '';
      this.preview();
      this.file.focus();
    });
    this.error = this.querySelector('[data-error]');
    this.button = this.querySelector('[data-submit]');
    this.side = 'front';
    this.placements = {};
    this.initPlacement();
    this.hatStyle = this.querySelector('[data-hat-style]');
    this.sideEnable = this.querySelector('[data-side-enable]');
    this.sideFile = this.querySelector('[data-side-artwork]');
    this.sideLink = this.querySelector('[data-side-link]');
    this.sideMethod = this.querySelector('[data-side-method]');
    if (this.hatStyle) {
      const initial = this.variants.find(v => String(v.id) === this.variantInput.value)?.options[0] || 'DTF';
      const [front, side] = initial.split(' + Side ');
      this.options[0].value = front;
      const requested = new URL(location.href).searchParams.get('hat_style');
      if (['Dad cap', 'Trucker hat', 'Snapback'].includes(requested)) this.hatStyle.value = requested;
      else if (side) this.hatStyle.value = 'Snapback';
      if (side && this.hatStyle.value === 'Snapback') { this.sideEnable.checked = true; this.sideMethod.value = side; }
      this.hatStyle.addEventListener('change', () => { this.side = 'front'; this.update(); });
      this.querySelectorAll('[data-hat-style-choice]').forEach(el => el.addEventListener('click', () => { this.hatStyle.value = el.dataset.hatStyleChoice; this.side = 'front'; this.update(); }));
      this.sideEnable.addEventListener('change', () => { this.side = this.sideEnable.checked ? 'side' : 'front'; this.update(); });
      this.sideMethod.addEventListener('change', () => this.update());
      this.sideFile.addEventListener('change', () => { this.validateFile(this.sideFile); this.resetUploadPlacement('side'); this.error.textContent = ''; this.preview(); });
      this.sideLink.addEventListener('input', () => { this.sideFile.setCustomValidity(''); this.error.textContent = ''; });
    }
    this.methodOption = this.options.find(el => /printing method/i.test(el.dataset.optionName));
    this.printOption = this.options.find(el => /print setup/i.test(el.dataset.optionName));
    this.sizeOption = this.options.find(el => /size/i.test(el.dataset.optionName));
    this.shirtType = this.querySelector('[data-shirt-type]');
    this.colorPalette = this.querySelector('[data-color-palette]') || this.querySelector('.izz-swatches');
    this.originalColors = this.colorPalette?.innerHTML;
    this.colorCatalog = JSON.parse(this.querySelector('[data-color-catalog]')?.textContent || '{}');
    this.shirtType?.addEventListener('change', () => { this.refreshSizes(); this.refreshColors(); this.update(); });
    this.method = this.methodOption?.value === 'Screen printing' ? 'screen' : 'dtf';
    this.manualMethod = false;
    this.ink = [...this.querySelectorAll('[data-ink]')];
    this.inkCount = this.querySelector('[data-ink-count]');
    this.inkCount?.addEventListener('input', () => this.update());
    this.querySelectorAll('[data-count-step]').forEach(button => button.addEventListener('click', () => {
      this.inkCount.value = String(Math.max(1, Math.min(6, (Number(this.inkCount.value) || 1) + Number(button.dataset.countStep))));
      this.update();
    }));
    this.screenNotice = this.querySelector('[data-screen-notice]');
    this.querySelector('[data-screen-close]')?.addEventListener('click', () => this.screenNotice.close());
    this.querySelector('[data-screen-info]')?.addEventListener('click', () => this.screenNotice.showModal());
    this.quotePanel = this.querySelector('[data-quote-panel]');
    [this.file, this.backFile, this.link, this.backLink, this.reuseArtwork].filter(Boolean).forEach(input => input.addEventListener(input.type === 'url' ? 'input' : 'change', () => { this.quoteArtwork = {}; this.quotePanel.hidden = true; }));
    if (this.methodOption) this.methodOption.closest('label').hidden = true;
    this.querySelectorAll('[data-method]').forEach(el => el.addEventListener('click', () => {
      this.manualMethod = true;
      this.method = el.dataset.method;
      if (this.methodOption) this.methodOption.value = this.method === 'screen' ? 'Screen printing' : 'DTF';
      this.update();
    }));
    this.querySelectorAll('[data-qty-step]').forEach(el => el.addEventListener('click', () => {
      const next = Math.max(Number(this.qty.min) || 1, (Number(this.qty.value) || 1) + Number(el.dataset.qtyStep) * (Number(this.qty.step) || 1));
      this.qty.value = String(this.qty.max ? Math.min(next, Number(this.qty.max)) : next); this.update();
    }));
    this.querySelectorAll('[data-quick-quantity]').forEach(el => el.addEventListener('click', () => { this.qty.value = el.dataset.quickQuantity; this.update(); }));
    this.ink.forEach(el => el.addEventListener('input', () => this.updateInk(el)));
    this.querySelectorAll('[data-ink-step]').forEach(el => el.addEventListener('click', () => {
      const input = this.ink.find(field => field.dataset.ink === el.dataset.inkSide);
      input.value = String(Math.max(0, Math.min(6, Number(input.value) + Number(el.dataset.inkStep))));
      this.updateInk(input);
    }));
    this.querySelector('[data-request-quote]')?.addEventListener('click', () => this.openQuote());
    this.quotePanel?.querySelector('form').addEventListener('submit', event => { if (!this.qty.reportValidity() || !this.validateColor()) { event.preventDefault(); return; } this.updateQuote(); });
    if (this.querySelector('[data-quote-success]')) this.quotePanel.hidden = false;
    this.querySelector('.izz-colors')?.addEventListener('change', event => { if (event.target.matches('[data-shirt-color]')) { this.preview(); if (this.quotePanel) this.updateQuote(); } });
    this.classList.add('izz-enhanced');
    this.options.forEach(el => el.addEventListener('change', () => { if (el === this.methodOption) this.method = el.value === 'Screen printing' ? 'screen' : 'dtf'; this.update(); }));
    this.qty.addEventListener('input', () => this.update());
    [this.file, this.backFile].forEach(el => el.addEventListener('change', () => { this.error.textContent = ''; this.validateFile(el); this.resetUploadPlacement(el === this.backFile ? 'back' : 'front'); this.preview(); }));
    this.link.addEventListener('input', () => { this.file.setCustomValidity(''); this.error.textContent = ''; });
    this.querySelectorAll('[data-view]').forEach(el => el.addEventListener('click', () => { this.side = el.dataset.view; this.preview(); }));
    this.form.addEventListener('submit', event => this.submit(event));
    this.update();
    this.loadPrices();
  }
  async loadPrices() {
    try {
      const response = await fetch(this.dataset.priceUrl);
      if (!response.ok) throw new Error('Unavailable');
      const data = await response.json();
      if (data.encoding === "gzip-base64") {
        const bytes = Uint8Array.from(atob(data.payload), char => char.charCodeAt(0));
        const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream("gzip"));
        this.retail = await new Response(stream).json();
      } else this.retail = data;
      if (this.shirtType) {
        this.shirtType.replaceChildren(...Object.entries(this.retail.products).filter(([, product]) => product.kind === 'tee').sort(([a], [b]) => a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true })).map(([name]) => new Option(name, name)));
        this.shirtType.value = this.retail.defaultProducts.tee;
      }
      this.refreshSizes();
      this.refreshColors();
    } catch { this.pricingFailed = true; }
    if (this.editKey && !this.pricingFailed) this.restoreCartItem();
    this.update();
  }
  updateInk(input) {
    if (input.value === '') { this.updatePricing(); return; }
    input.value = String(Math.max(0, Math.min(6, Math.trunc(Number(input.value) || 0))));
    const front = Number(this.ink[0].value), back = Number(this.ink[1].value);
    if (!front && !back) { input.value = '1'; }
    const hasFront = Number(this.ink[0].value) > 0, hasBack = Number(this.ink[1].value) > 0;
    const small = this.printOption.value.toLowerCase().includes('small front');
    this.printOption.value = hasFront && hasBack ? (small ? 'Small Front + Large Back' : 'Large Front + Large Back') : hasBack ? 'Large Back' : (small ? 'Small Front / Left Chest' : 'Large Front');
    this.update();
  }
  selectedPricingProduct() {
    const name = this.shirtType?.value || this.retail?.defaultProducts?.[this.dataset.kind];
    return this.retail?.products?.[name];
  }
  selectedPricingGroup() {
    return Object.values(this.selectedPricingProduct()?.groups || {}).find(group => group.sizes.includes(this.sizeOption.value));
  }
  refreshSizes() {
    if (!this.sizeOption || !this.retail?.products) return;
    const value = this.sizeOption.value;
    const allowed = this.colorCatalog?.[this.shirtType?.value]?.sizes;
    const sizes = Object.values(this.selectedPricingProduct()?.groups || {}).flatMap(group => group.sizes).filter(size => !allowed || allowed.includes(size));
    this.sizeOption.replaceChildren(...sizes.map(size => new Option(size, size)));
    this.sizeOption.value = sizes.includes(value) ? value : (sizes.includes('S') ? 'S' : sizes[0] || '');
  }
  refreshColors() {
    if (!this.colorPalette) return;
    const value = this.querySelector('[data-shirt-color]:checked')?.value;
    const config = this.colorCatalog[this.shirtType?.value];
    if (!config) {
      this.colorPalette.innerHTML = this.originalColors;
    } else {
      this.colorPalette.replaceChildren(...config.colors.map(color => {
        const label = document.createElement('label'); label.className = 'izz-swatch'; label.title = color.name;
        const radio = document.createElement('input'); radio.type = 'radio'; radio.name = 'properties[Shirt color]'; radio.value = color.name; radio.dataset.shirtColor = ''; radio.required = true;
        const swatch = document.createElement('span'); swatch.style.setProperty('--swatch', color.hex);
        const name = document.createElement('span'); name.className = 'visually-hidden'; name.textContent = color.name;
        label.append(radio, swatch, name); return label;
      }));
    }
    this.querySelectorAll('[data-shirt-color]').forEach(input => { input.checked = input.value === value; });
  }
  validateColor() {
    const input = this.querySelector('[data-shirt-color]');
    return !input || input.reportValidity();
  }
  retailPrice(quantity, front, back) {
    if (!this.retail || this.retail.currency !== this.dataset.currency || quantity < 1 || quantity > this.retail.maxQuantity || !Number.isInteger(quantity)) return null;
    const group = this.selectedPricingGroup();
    if (!group) return null;
    if (this.method !== 'screen') {
      const setup = this.printOption.value;
      if (typeof group.dtfTotals?.[setup] === 'string') {
        let subtotal = 0;
        group.dtfTotals[setup] = group.dtfTotals[setup].split(',').map(delta => (subtotal += parseInt(delta, 36)));
      }
      const total = group.dtfTotals?.[setup]?.[quantity - 1];
      return Number.isInteger(total) ? total / quantity : group.dtf[setup] ?? null;
    }
    const key = `${Math.max(front, back)}-${Math.min(front, back)}`;
    if (typeof group.screen[key] === 'string') {
      let subtotal = 0;
      group.screen[key] = group.screen[key].split(',').map(delta => (subtotal += parseInt(delta, 36)));
    }
    const total = group.screen[key]?.[quantity - 1];
    return Number.isInteger(total) ? total / quantity : null;
  }
  updatePricing() {
    if (!this.ink.length) return;
    const screen = this.method === 'screen';
    this.querySelectorAll('[data-method]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.method === this.method)));
    this.querySelector('[data-decoration-property]').value = screen ? 'Screen printing' : 'DTF';
    this.querySelector('[data-ink-controls]').hidden = !screen;
    this.querySelector('[data-full-color]').hidden = screen;
    this.querySelector('[data-bulk-shortcuts]').hidden = !screen;
    this.ink.forEach(el => { el.disabled = !screen; });
    this.inkCount.disabled = !screen;
    this.querySelector('[data-screen-info]').hidden = !screen;
    this.querySelectorAll('[data-quick-quantity]').forEach(el => el.setAttribute('aria-pressed', String(Number(el.dataset.quickQuantity) === Number(this.qty.value))));
    this.button.hidden = screen;
    this.querySelector('[data-request-quote]').hidden = !screen;
    if (!screen) this.quotePanel.hidden = !this.querySelector('[data-quote-success]');
    const q = Number(this.qty.value), front = Number(this.ink[0].value), back = Number(this.ink[1].value);
    const validInk = this.ink.every(el => el.value !== '' && Number.isInteger(Number(el.value)) && Number(el.value) >= 0 && Number(el.value) <= 6);
    this.unitCents = (!screen || validInk) ? this.retailPrice(q, front, back) : null;
    const defaultType = !this.shirtType || this.shirtType.value === this.retail?.defaultProducts?.tee;
    this.needsQuote = screen || !defaultType || !this.variant?.available || this.unitCents !== this.variant.price;
    if (this.shippingEstimate()?.cents === null) this.needsQuote = true;
    this.button.hidden = false;
    this.querySelector('[data-request-quote]').hidden = true;
    this.lineCents = this.unitCents != null && Number.isInteger(q) && q > 0 ? Math.round(this.unitCents * q) : null;
    this.button.disabled = this.busy || this.lineCents == null;
    this.querySelector('[data-submit-label]').textContent = this.busy ? this.strings.cart_added : this.strings.add;
    const formatted = this.unitCents != null ? this.money(this.unitCents) : '—';
    this.querySelector('[data-unit-price]').textContent = formatted;
    this.querySelector('[data-quick-price]').textContent = formatted;
    this.querySelector('[data-quick-label]').textContent = screen ? this.strings.pricing.estimate : this.defaultQuickLabel;
    this.querySelector('[data-line-total]').textContent = this.lineCents != null ? this.money(this.lineCents) : '—';
    this.querySelector('[data-total-label]').textContent = screen ? this.strings.pricing.total : this.defaultTotalLabel;
    let note = screen ? this.strings.pricing.bulk_note : this.strings.pricing.dtf_note;
    if (!this.retail) note = this.pricingFailed ? this.strings.pricing.failed : this.strings.pricing.loading;
    else if (this.unitCents == null) note = this.strings.pricing.unsupported;
    if (!screen && this.unitCents != null && this.needsQuote) note = this.strings.pricing.custom_quote;
    this.querySelector('[data-pricing-note]').textContent = this.unitCents == null ? note : this.strings.cart_note;
    this.querySelector('[data-unit-price]').setAttribute('aria-live', 'polite');
    this.updateQuote();
  }
  updateQuote() {
    if (!this.quotePanel) return;
    const q = Number(this.qty.value);
    const parts = this.ink.length ? [this.dataset.productTitle, 'Decoration: ' + (this.method === 'screen' ? 'Screen printing' : 'DTF'), 'Size: ' + this.sizeOption.value, 'Quantity: ' + this.qty.value, 'Color: ' + (this.querySelector('[data-shirt-color]:checked')?.value || ''), 'Print setup: ' + this.printOption.value, 'Front ink colors: ' + this.ink[0].value, 'Back ink colors: ' + this.ink[1].value] : [this.dataset.productTitle, 'Decoration: ' + this.options[0].value, 'Quantity: ' + this.qty.value, 'Preferred color: ' + this.querySelector('[name="properties[Preferred color]"]').value, 'Preferred style: ' + this.querySelector('[name="properties[Preferred style]"]').value];
    if (this.shirtType) parts.splice(3, 0, 'Shirt type: ' + this.shirtType.value);
    parts.push('Fulfillment: Colton Post Office, 265 N 7th St, Colton, CA 92324');
    if (this.unitCents != null) parts.push('Estimated average unit price: ' + this.money(this.unitCents), 'Estimated subtotal: ' + this.money(this.lineCents));
    else parts.push('Custom pricing requested');
    parts.push(...this.placementDescriptions());
    parts.push('Front / primary artwork download: ' + (this.quoteArtwork.primary || this.quotePanel.querySelector('[data-quote-link]').value || this.link.value));
    if (this.hasFront && this.hasBack) parts.push('Back artwork download: ' + (this.reuseArtwork?.checked ? this.quoteArtwork.primary || this.link.value : this.quoteArtwork.back || this.backLink?.value || ''), 'Back design: ' + (this.reuseArtwork?.checked ? 'Same as front' : 'Separate artwork'));
    const estimate = this.shippingEstimate();
    if (estimate) parts.push('Estimated packed weight: ' + estimate.weight.toFixed(2) + ' lb', 'Draft shipping estimate: ' + (estimate.cents == null ? 'Shipping quote required' : this.money(estimate.cents)), 'Estimated tax (8.75% of apparel subtotal): ' + this.money(this.taxCents(this.lineCents)));
    parts.push('Design / mixed-size notes: ' + this.form.querySelector('textarea').value);
    this.quotePanel.querySelector('[data-quote-description]').textContent = parts.slice(0,this.shirtType ? 11 : 10).join('\n');
    this.quotePanel.querySelector('[data-quote-body]').value = parts.join('\n');
  }
  money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency }).format(cents / 100); }
  update() {
    const quantity = Number(this.qty.value);
    if (this.ink.length && Number.isInteger(quantity) && quantity > 0) {
      if (!this.manualMethod && (this.previousQuantity == null || (quantity >= 10) !== (this.previousQuantity >= 10))) {
        this.method = quantity >= 10 ? 'screen' : 'dtf';
        if (this.methodOption) this.methodOption.value = this.method === 'screen' ? 'Screen printing' : 'DTF';
      }
      this.previousQuantity = quantity;
    }
    if (!this.defaultTotalLabel) this.defaultTotalLabel = this.querySelector('[data-total-label]')?.textContent;
    if (this.ink.length && !this.defaultQuickLabel) this.defaultQuickLabel = this.querySelector('[data-quick-label]').textContent;
    const snapback = this.hatStyle?.value === 'Snapback';
    if (this.hatStyle) {
      this.querySelector('h1').textContent = snapback ? this.strings.snapback_title : this.dataset.productTitle;
      this.querySelector('[data-snapback-panel]').hidden = !snapback;
      this.querySelector('[data-snapback-views]').hidden = !snapback;
      if (!snapback) { this.sideEnable.checked = false; this.side = 'front'; }
      this.sideEnabled = snapback && this.sideEnable.checked;
      this.querySelector('[data-side-fields]').hidden = !this.sideEnabled;
      this.querySelectorAll('[data-side-fields] input, [data-side-fields] select').forEach(el => { el.disabled = !this.sideEnabled; });
      this.sideFile.setCustomValidity('');
      this.querySelectorAll('[data-hat-style-choice]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.hatStyleChoice === this.hatStyle.value)));
      const url = new URL(location.href);
      if (this.hatStyle.value) url.searchParams.set('hat_style', this.hatStyle.value);
      history.replaceState(null, '', url);
    }
    const values = this.options.map(el => el.value);
    if (this.sideEnabled) values[0] += ' + Side ' + this.sideMethod.value;
    this.variant = this.variants.find(v => v.options.every((value, i) => value === values[i]));
    const v = this.variant;
    this.variantInput.value = v ? String(v.id) : '';
    this.button.disabled = !v?.available;
    this.querySelector('[data-submit-label]').textContent = v?.available ? this.strings.add : this.strings.unavailable;
    this.querySelector('[data-unit-price]').textContent = v ? this.money(v.price) : '—';
    this.querySelector('[data-line-total]').textContent = v ? this.money(v.price * Math.max(0, Number(this.qty.value) || 0)) : '—';
    if (v) {
      this.qty.min = v.min; this.qty.step = v.step;
      if (v.max !== null) this.qty.max = v.max; else this.qty.removeAttribute('max');
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    const print = values.join(' ').toLowerCase();
    this.hasFront = ['hat', 'bag'].includes(this.dataset.kind) || print.includes('front'); this.hasBack = print.includes('back');
    this.smallFront = print.includes('small front');
    if (this.ink.length) {
      this.ink[0].value = this.hasFront ? this.inkCount.value : '0';
      this.ink[1].value = this.hasBack ? this.inkCount.value : '0';
      this.updatePricing();
      if (this.method === 'screen' && !this.screenNoticeSeen) { this.screenNoticeSeen = true; this.screenNotice.showModal(); }
    }
    this.querySelector('[data-back-field]').hidden = !(this.hasFront && this.hasBack);
    this.backFile.disabled = !(this.hasFront && this.hasBack);
    this.updateBackArtwork();
    if (!this.ink.length) this.updateAccessoryPricing();
    this.updateOrderEstimate();
    if (!this.hasFront && this.hasBack) this.side = 'back';
    else if (this.hasFront && !this.hasBack && !this.hatStyle) this.side = 'front';
    this.preview();
    if (this.editKey) {
      this.querySelector('[data-submit-label]').textContent = this.busy ? this.strings.cart_added : this.strings.edit_save;
      this.querySelector('[data-edit-banner]').hidden = false;
      if (this.editMissing) { this.button.disabled = true; this.error.textContent = this.strings.edit_missing; }
    }
  }
  restoreCartItem() {
    const item = window.IzzOrderBasket?.read().find(line => line.key === this.editKey && line.handle === this.dataset.productHandle);
    if (!item) { this.editMissing = true; return; }
    this.originalEditItem = JSON.stringify(item);
    this.savedEditItem = item;
    if (this.shirtType) this.shirtType.value = item.shirtType;
    this.refreshSizes(); this.refreshColors();
    if (this.sizeOption) this.sizeOption.value = item.size;
    if (this.printOption) this.printOption.value = item.printSetup;
    this.qty.value = String(item.quantity);
    this.manualMethod = true; this.method = item.method;
    if (this.methodOption) this.methodOption.value = item.method === 'screen' ? 'Screen printing' : 'DTF';
    if (!this.ink.length) this.options[0].value = item.method;
    if (this.inkCount) this.inkCount.value = String(item.inkColors || 1);
    for (const input of this.form.elements) {
      const match = input.name?.match(/^properties\[(.+)\]$/);
      if (!match || input.type === 'file' || input.type === 'hidden' || input.type === 'radio' || !(match[1] in (item.properties || {}))) continue;
      if (input.type === 'checkbox') input.checked = Boolean(item.properties[match[1]]);
      else input.value = item.properties[match[1]];
    }
    this.querySelectorAll('[data-shirt-color]').forEach(input => { input.checked = input.value === item.color; });
    if (this.hatStyle) this.hatStyle.value = item.hatStyle || item.properties?.['Preferred style'] || 'Dad cap';
    if (this.sideEnable) this.sideEnable.checked = Boolean(item.sideEnabled);
    if (this.sideMethod && item.sideMethod) this.sideMethod.value = item.sideMethod;
    this.link.value = (item.hasFront ? item.artwork?.primary : item.artwork?.back) || '';
    this.backLink.value = item.hasFront && item.hasBack ? item.artwork?.back || '' : '';
    if (this.sideLink) this.sideLink.value = item.artwork?.side || '';
    if (this.reuseArtwork) this.reuseArtwork.checked = item.reuseArtwork ?? (item.hasFront && item.hasBack && item.artwork?.primary === item.artwork?.back);
    this.placements = item.placements || {};
    if (!item.placements) {
      for (const side of ['front', 'back', 'side']) {
        const text = item.properties?.[side[0].toUpperCase() + side.slice(1) + ' artwork placement'] || '';
        const match = text.match(/X ([\d.]+)%, Y ([\d.]+)%, size ([\d.]+)%.*\((small|large)\)/);
        if (match) this.placements[[this.dataset.kind, this.hatStyle?.value || '', side, match[4]].join('|')] = {x:Number(match[1]), y:Number(match[2]), scale:Number(match[3])};
      }
    }
    this.screenNoticeSeen = true;
    this.side = item.hasFront ? 'front' : 'back';
  }
  artworkForSide(side) {
    let input = this.file, link = this.link;
    if (side === 'side') { if (!this.sideEnabled) return null; input = this.sideFile; link = this.sideLink; }
    else if (side === 'back' && this.hasFront && !this.reuseArtwork?.checked) { input = this.backFile; link = this.backLink; }
    if (input?.files[0]) return input.files[0];
    if (!this.editKey || !link?.value.trim()) return null;
    try {
      const url = new URL(link.value.trim());
      if (!['https:', 'http:'].includes(url.protocol)) return null;
      return { url:url.href, name:decodeURIComponent(url.pathname.split('/').pop()), size:0 };
    } catch { return null; }
  }
  validateFile(input) {
    const file = input.files[0];
    let message = '';
    if (file && file.size > 20 * 1024 * 1024) message = this.strings.file_large;
    if (file && !/\.(png|jpe?g|pdf)$/i.test(file.name)) message = this.strings.file_type;
    input.setCustomValidity(message); if (message) this.error.textContent = message;
    return !message;
  }
  preview() {
    const hat = this.querySelector('[data-hat-photo]');
    if (hat) {
      const style = this.querySelector('[data-hat-style]')?.value;
      const key = style === 'Snapback' ? (this.side === 'side' ? 'snapbackSide' : 'snapback') : style === 'Trucker hat' ? 'trucker' : 'dad';
      const source = hat.dataset[key + 'Src'];
      if (hat.getAttribute('src') !== source) {
        hat.src = source;
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) hat.animate([{ transform: 'perspective(900px) rotateY(-18deg)', opacity: .45 }, { transform: 'perspective(900px) rotateY(0)', opacity: 1 }], { duration: 420, easing: 'ease-out' });
      }
      hat.alt = hat.dataset[key + 'Alt'];
    }
    const back = this.side === 'back';
    const color = this.querySelector('[data-shirt-color]:checked')?.value;
    const shortModel = this.querySelector('[data-model-image]');
    const longModel = this.querySelector('[data-long-sleeve-image]');
    const youthModel = this.querySelector('[data-youth-image]');
    const config = this.colorCatalog[this.shirtType?.value];
    const preview = this.querySelector('.izz-preview');
    const selected = this.querySelector('[data-shirt-color]:checked');
    const longSleeve = config?.preview === 'long-sleeve';
    const useLongModel = longSleeve && Boolean(longModel);
    const pocket = this.querySelector('[data-pocket-preview]');
    if (pocket) {
      const pocketStyle = ['Gildan DryBlend Pocket T-Shirt 8300', 'Gildan Ultra Cotton Long Sleeve Pocket T-Shirt 2410'].includes(this.shirtType?.value);
      pocket.toggleAttribute('hidden', !pocketStyle || back || !color);
      pocket.querySelector('[data-pocket-shape]').setAttribute('transform', longSleeve ? 'translate(610 507)' : 'translate(617 548)');
    }

    const useYouthModel = this.shirtType?.value.startsWith('Youth') && Boolean(youthModel);
    const model = useYouthModel ? youthModel : useLongModel ? longModel : shortModel;
    if (youthModel) youthModel.hidden = !useYouthModel;
    preview.classList.toggle('izz-youth-active', Boolean(useYouthModel));
    if (longModel) longModel.hidden = !useLongModel;
    if (shortModel && (useLongModel || useYouthModel)) shortModel.hidden = true;
    preview.classList.toggle('izz-long-sleeve-active', useLongModel);
    this.querySelectorAll('[data-long-sleeve]').forEach(path => { path.style.display = longSleeve ? '' : 'none'; path.removeAttribute('hidden'); });
    this.querySelectorAll('[data-short-sleeve]').forEach(path => { path.style.display = longSleeve ? 'none' : ''; });
    if (model) {
      const images = JSON.parse(this.querySelector('[data-model-images]').textContent);
      const modelAllowed = useYouthModel || useLongModel || (!longSleeve && !this.shirtType?.value.startsWith('Youth'));
      const exactSource = useYouthModel ? (back ? youthModel.dataset.backSrc : youthModel.dataset.frontSrc) : useLongModel ? (back ? longModel.dataset.backSrc : longModel.dataset.src) : color ? images[back ? 'back' : 'front'][color] : null;
      const source = modelAllowed && color ? exactSource || images[back ? 'back' : 'front'].White : null;
      const caption = this.querySelector('.izz-art-caption');
      if (caption) {
        caption.dataset.originalNote ||= caption.textContent;
        caption.textContent = caption.dataset.originalNote;
      }
      model.hidden = !source;
      preview.classList.toggle('izz-model-active', Boolean(source));
      const tint = this.querySelector('[data-model-tint]');
      if (tint) {
        const shade = selected?.nextElementSibling.style.getPropertyValue('--swatch') || '#ffffff';
        tint.style.setProperty('--model-tint', shade);
        tint.dataset.side = back ? 'back' : 'front';
        const tinted = Boolean(source && !exactSource);
        tint.dataset.active = String(tinted);
        tint.toggleAttribute('hidden', !tinted || model.getAttribute('src') !== source || !model.complete);
        model.onload = () => tint.toggleAttribute('hidden', tint.dataset.active !== 'true' || model.hidden);
      }
      const longColor = this.querySelector('[data-long-sleeve-color]');
      if (longColor) {
        longColor.style.setProperty('--long-sleeve-color', selected?.nextElementSibling.style.getPropertyValue('--swatch') || '#ffffff');
        longColor.dataset.side = back ? 'back' : 'front';
        longColor.querySelectorAll('feFuncR, feFuncG, feFuncB').forEach(channel => { channel.setAttribute('slope', color === 'White' ? '1.15' : '2.6'); channel.setAttribute('intercept', color === 'White' ? '0.82' : '0.52'); });
        longColor.toggleAttribute('hidden', !useLongModel || color === 'Black');
      }
      const youthColor = this.querySelector('[data-youth-color]');
      if (youthColor) {
        youthColor.style.setProperty('--youth-color', selected?.nextElementSibling.style.getPropertyValue('--swatch') || '#ffffff');
        youthColor.querySelector('[data-youth-color-image]').setAttribute('href', useYouthModel ? source : youthModel.dataset.frontSrc);
        youthColor.toggleAttribute('hidden', !useYouthModel || color === 'Black');
      }
      if (source && model.getAttribute('src') !== source) model.src = source;
    }
    if (this.colorPalette) {
      this.querySelector('[data-color-name]').textContent = color || this.strings.choose_color;
      this.querySelector('.izz-preview-garment').style.setProperty('--garment-color', selected?.nextElementSibling.style.getPropertyValue('--swatch') || '#dddddd');
      preview.style.setProperty('--preview-ink', ['Black','Admiral Blue','Burnt Orange','Red','Royal','True Navy','Navy','Forest','Maroon','Garnet','Purple','Charcoal','Dark Heather'].includes(color) ? '#fff' : '#24241f');
      const status = this.querySelector('[data-color-status]');
      if (status) status.textContent = !color ? this.strings.choose_color : config?.colors.find(item => item.name === color)?.caseOnly ? this.strings.color_case : config ? this.strings.color_stock : '';
    }
    this.querySelectorAll('[data-view]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.view === this.side)));
    this.querySelector('.izz-preview').dataset.side = this.side;
    const zone = this.querySelector('.izz-print-zone');
    zone.dataset.zone = !back && this.smallFront ? 'small' : 'large';
    zone.hidden = back ? !this.hasBack : !this.hasFront;
    const sideView = this.dataset.kind === 'hat' && this.side === 'side';
    const artwork = this.artworkForSide(sideView ? 'side' : back ? 'back' : 'front');
    const image = this.querySelector('[data-preview-image]');
    this.activeArtwork = artwork;
    const placeholder = this.querySelector('[data-placeholder]');
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.previewUrl = null;
    image.removeAttribute('src');
    image.hidden = true; placeholder.hidden = Boolean(this.blankPreview);
    if (this.clearArtwork) this.clearArtwork.hidden = !['front', 'back', 'side'].some(side => this.artworkForSide(side));
    if (artwork && /\.(png|jpe?g)$/i.test(artwork.name) && artwork.size <= 20 * 1024 * 1024) {
      this.blankPreview = false;
      this.previewUrl = artwork.url ? null : URL.createObjectURL(artwork); image.src = artwork.url || this.previewUrl; image.hidden = false; placeholder.hidden = true;
    }
    if (['hat', 'bag'].includes(this.dataset.kind)) zone.hidden = image.hidden;
    if (this.blankPreview) zone.hidden = true;
    this.renderPlacement();
    if (this.sideFile) this.querySelector('[data-side-status]').textContent = this.sideEnabled ? (this.sideFile.files[0]?.name || '') : '';
    this.querySelector('[data-file-status]').textContent = this.file.files[0]?.name || (this.editKey && this.link.value ? this.strings.edit_saved_art : '');
    if (artwork && /\.pdf$/i.test(artwork.name)) this.querySelector('[data-file-status]').textContent += ' — ' + this.strings.pdf;
  }
  initPlacement() {
    this.mover = this.querySelector('[data-artwork-mover]');
    this.placementControls = this.querySelector('[data-placement-controls]');
    this.placementSize = this.querySelector('[data-placement-size]');
    this.placementX = this.querySelector('[data-placement-x]');
    this.placementY = this.querySelector('[data-placement-y]');
    if (!this.mover) return;
    this.querySelector('[data-preview-image]').addEventListener('load', () => this.renderPlacement());
    [this.placementSize, this.placementX, this.placementY].forEach((input, i) => input.addEventListener('input', () => {
      const p = this.currentPlacement(); p[['scale','x','y'][i]] = Number(input.value); this.renderPlacement();
    }));
    this.querySelector('[data-placement-reset]').addEventListener('click', () => {
      this.placements[this.placementKey()] = { x:50, y:50, scale:75 }; this.renderPlacement();
    });
    this.mover.addEventListener('pointerdown', event => {
      if (event.button !== 0 || this.mover.hidden) return;
      event.preventDefault(); this.mover.focus({ preventScroll:true });
      const p = this.currentPlacement(), rect = this.querySelector('.izz-print-zone').getBoundingClientRect();
      this.dragPlacement = { id:event.pointerId, key:this.placementKey(), x:event.clientX, y:event.clientY, startX:p.x, startY:p.y, width:rect.width, height:rect.height };
      this.mover.setPointerCapture(event.pointerId);
    });
    this.mover.addEventListener('pointermove', event => {
      const drag = this.dragPlacement;
      if (!drag || drag.id !== event.pointerId || drag.key !== this.placementKey()) return;
      const p = this.currentPlacement(); p.x = drag.startX + (event.clientX-drag.x)/drag.width*100; p.y = drag.startY + (event.clientY-drag.y)/drag.height*100;
      this.renderPlacement();
    });
    const finish = () => { this.dragPlacement = null; };
    ['pointerup','pointercancel','lostpointercapture'].forEach(type => this.mover.addEventListener(type, finish));
    this.mover.addEventListener('keydown', event => {
      const delta = {ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]}[event.key];
      if (!delta) return; event.preventDefault(); const p = this.currentPlacement(), step = event.shiftKey ? 5 : 1;
      p.x += delta[0]*step; p.y += delta[1]*step; this.renderPlacement();
    });
    this.placementObserver = new ResizeObserver(() => this.renderPlacement());
    this.placementObserver.observe(this.querySelector('.izz-print-zone'));
  }
  placementKey() {
    return [this.dataset.kind, this.hatStyle?.value || '', this.side, this.side === 'front' && this.smallFront ? 'small' : 'large'].join('|');
  }
  currentPlacement() {
    const key = this.placementKey();
    return this.placements[key] ||= { x:50, y:50, scale:75 };
  }
  resetUploadPlacement(side) {
    Object.keys(this.placements).forEach(key => { if (key.split('|')[2] === side || (side === 'front' && !this.backFile.files.length && key.split('|')[2] === 'back')) delete this.placements[key]; });
  }
  renderPlacement() {
    if (!this.mover) return;
    const image = this.querySelector('[data-preview-image]'), zone = this.querySelector('.izz-print-zone');
    const shown = !image.hidden && !zone.hidden && Boolean(this.activeArtwork);
    this.mover.hidden = !shown; this.placementControls.hidden = !shown; zone.classList.toggle('izz-placement-active', shown);
    if (!shown) { this.syncPlacement(); return; }
    const p = this.currentPlacement(), rect = zone.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const ratio = image.naturalWidth && image.naturalHeight ? image.naturalWidth/image.naturalHeight : 1;
    p.scale = Math.max(15, Math.min(100, p.scale));
    const width = Math.min(rect.width, rect.height*ratio)*p.scale/100, height = width/ratio;
    const halfX = width/rect.width*50, halfY = height/rect.height*50;
    p.x = Math.max(halfX, Math.min(100-halfX, p.x)); p.y = Math.max(halfY, Math.min(100-halfY, p.y));
    this.mover.style.left = p.x+'%'; this.mover.style.top = p.y+'%';
    this.mover.style.width = width/rect.width*100+'%'; this.mover.style.height = height/rect.height*100+'%';
    this.placementSize.value = p.scale; this.placementX.min = Math.ceil(halfX); this.placementX.max = Math.floor(100-halfX); this.placementX.value = p.x;
    this.placementY.min = Math.ceil(halfY); this.placementY.max = Math.floor(100-halfY); this.placementY.value = p.y;
    this.querySelector('[data-placement-size-output]').textContent = p.scale+'%';
    this.querySelector('[data-placement-status]').textContent = 'X: '+Math.round(p.x)+'% · Y: '+Math.round(p.y)+'%';
    this.syncPlacement();
  }
  placementDescriptions() {
    const descriptions = [];
    ['front','back','side'].forEach(side => {
      const active = side === 'front' ? this.hasFront : side === 'back' ? this.hasBack : this.sideEnabled;
      const file = this.artworkForSide(side);
      if (active && file && /\.(png|jpe?g)$/i.test(file.name) && file.size <= 20*1024*1024) {
        const key = [this.dataset.kind, this.hatStyle?.value || '', side, side === 'front' && this.smallFront ? 'small' : 'large'].join('|');
        this.placements[key] ||= { x:50, y:50, scale:75 };
      }
    });
    Object.entries(this.placements || {}).forEach(([key,p]) => {
      const [kind,style,side,zone] = key.split('|');
      if (kind !== this.dataset.kind || (style && style !== this.hatStyle?.value)) return;
      if ((side === 'front' && !this.hasFront) || (side === 'back' && !this.hasBack) || (side === 'side' && !this.sideEnabled)) return;
      if (side === 'front' && zone !== (this.smallFront ? 'small' : 'large')) return;
      const file = this.artworkForSide(side);
      if (!file || !/\.(png|jpe?g)$/i.test(file.name)) return;
      descriptions.push(side.charAt(0).toUpperCase()+side.slice(1)+' artwork placement: X '+p.x.toFixed(1)+'%, Y '+p.y.toFixed(1)+'%, size '+p.scale+'% of printable area ('+zone+'). Preview guide; confirm before production.');
    });
    return descriptions;
  }
  syncPlacement() {
    this.form.querySelectorAll('[data-placement-property]').forEach(input => input.remove());
    this.placementDescriptions().forEach(description => {
      const input = document.createElement('input'); input.type = 'hidden'; input.dataset.placementProperty = '';
      const split = description.indexOf(':'); input.name = 'properties['+description.slice(0,split)+']'; input.value = description.slice(split+2); this.form.append(input);
    });
    if (this.quotePanel) this.updateQuote();
  }
  async submit(event) {
    event.preventDefault();
    await this.addToOrderCart();
  }
  updateBackArtwork() {
    const twoSides = this.hasFront && this.hasBack;
    const reuse = twoSides && this.reuseArtwork?.checked;
    if (this.reuseArtwork) this.reuseArtwork.disabled = !twoSides;
    this.querySelector('[data-reuse-field]')?.toggleAttribute('hidden', !twoSides);
    this.backFile.disabled = !twoSides || reuse;
    if (this.backLink) { this.backLink.disabled = !twoSides || reuse; this.backLink.closest('label').hidden = !twoSides || reuse; }
    this.querySelector('[data-back-field]').hidden = !twoSides || reuse;
    this.backFile.setCustomValidity('');
  }
  validateArtwork() {
    this.file.setCustomValidity(''); this.backFile.setCustomValidity('');
    if (!this.file.files.length && !this.link.value.trim()) {
      this.file.setCustomValidity(this.strings.artwork_required); this.error.textContent = this.strings.artwork_required; this.file.reportValidity(); return false;
    }
    if (this.hasFront && this.hasBack && !this.reuseArtwork?.checked && !this.backFile.files.length && !this.backLink?.value.trim()) {
      this.backFile.setCustomValidity(this.strings.back_required); this.error.textContent = this.strings.back_required; this.backFile.reportValidity(); return false;
    }
    return this.validateFile(this.file) && (this.backFile.disabled || this.validateFile(this.backFile));
  }
  shippingEstimate() {
    const config = this.retail?.shipping;
    const q = Number(this.qty.value);
    if (!config || !Number.isInteger(q) || q < 1) return null;
    const weight = Math.round((config.weights[this.dataset.kind] * q + Math.ceil(q / config.itemsPerParcel) * config.packagingPerParcel) * 100) / 100;
    if (config.defaultDelivery === 'pickup') return { weight, cents: 0 };
    const tier = config.tiers.find(t => weight <= t.maxWeight);
    return { weight, cents: tier?.priceCents ?? null };
  }
  updateAccessoryPricing() {
    const q = Number(this.qty.value);
    const method = this.options[0].value;
    const group = this.retail?.accessories?.[this.dataset.kind];
    if (typeof group?.[method] === 'string') {
      let subtotal = 0; group[method] = group[method].split(',').map(delta => (subtotal += parseInt(delta, 36)));
    }
    const total = group?.[method]?.[q - 1];
    this.lineCents = Number.isInteger(total) ? total + (this.sideEnabled ? 500 * q : 0) : null;
    this.unitCents = this.lineCents == null ? null : this.lineCents / q;
    this.needsQuote = this.lineCents == null || !this.variant?.available || this.lineCents !== this.variant.price * q;
    if (this.shippingEstimate()?.cents === null) this.needsQuote = true;
    this.button.hidden = false;
    this.button.disabled = this.busy || this.lineCents == null;
    this.querySelector('[data-submit-label]').textContent = this.busy ? this.strings.cart_added : this.strings.add;
    this.querySelector('[data-request-quote]').hidden = true;
    this.querySelector('[data-unit-price]').textContent = this.unitCents == null ? '—' : this.money(this.unitCents);
    this.querySelector('[data-line-total]').textContent = this.lineCents == null ? '—' : this.money(this.lineCents);
    this.querySelector('[data-pricing-note]').textContent = this.strings.cart_note;
    this.updateQuote();
  }
  async orderArtworkIdentity() {
    const identify = async (file, link) => {
      if (!file) {
        const url = link?.trim() || '';
        for (const side of ['primary', 'back', 'side']) {
          if (url && this.savedEditItem?.artwork?.[side] === url) return this.savedEditItem.artworkIdentity?.[side] || url;
        }
        return url;
      }
      if (!crypto.subtle) return 'unique:' + crypto.randomUUID();
      const hash = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
      return 'sha256:' + Array.from(new Uint8Array(hash), b => b.toString(16).padStart(2, '0')).join('');
    };
    const primary = await identify(this.file.files[0], this.link.value);
    const back = this.hasFront && this.hasBack ? (this.reuseArtwork?.checked ? primary : await identify(this.backFile?.files[0], this.backLink?.value)) : this.hasBack ? primary : '';
    return { primary: this.hasFront ? primary : '', back };
  }
  async saveOrderArtwork() {
    const artwork = { primary: this.link.value.trim(), back: this.reuseArtwork?.checked ? this.link.value.trim() : this.backLink?.value.trim() || '', side: this.sideEnabled ? this.sideLink?.value.trim() || '' : '' };
    const uploads = { primary: this.file.files[0], back: !this.backFile.disabled ? this.backFile.files[0] : null, side: this.sideEnabled ? this.sideFile?.files[0] : null };
    if (Object.values(uploads).some(Boolean)) {
      const variant = this.variants.find(v => v.available && !v.options.includes('Screen printing'));
      if (!variant) throw new Error(this.strings.cart_failed);
      const data = new FormData(); data.set('id', String(variant.id)); data.set('quantity', String(variant.min || 1)); data.set('properties[_Artwork reference]', crypto.randomUUID());
      const names = { primary: 'Artwork', back: 'Back artwork', side: 'Side artwork' };
      for (const [side, file] of Object.entries(uploads)) if (file) data.set('properties[' + names[side] + ']', file);
      const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const item = await response.json();
      if (!response.ok || item.status || !item.key) throw new Error(item.description || this.strings.cart_failed);
      const cleanup = await fetch(this.dataset.cartUrl + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 0 }) });
      if (!cleanup.ok) throw new Error(this.strings.quote_cleanup);
      for (const [side, file] of Object.entries(uploads)) if (file) {
        artwork[side] = item.properties?.[names[side]] || '';
        if (!artwork[side]) throw new Error(this.strings.cart_failed);
      }
    }
    if (this.hasFront && this.hasBack && this.reuseArtwork?.checked) artwork.back = artwork.primary;
    if (!this.hasFront && this.hasBack) { artwork.back = artwork.primary; artwork.primary = ''; }
    return artwork;
  }
  async addToOrderCart() {
    if (this.editMissing || this.busy || this.lineCents == null || !this.qty.reportValidity() || !this.validateColor() || !this.validateArtwork() || !this.form.reportValidity()) return;
    if (this.sideEnabled && !this.sideFile.files.length && !this.sideLink.value.trim()) { this.error.textContent = this.strings.side_required; return; }
    if (this.sideEnabled && !this.validateFile(this.sideFile)) return;
    if (!window.IzzOrderBasket) { this.error.textContent = this.strings.cart_failed; return; }
    if (!this.editKey && window.IzzOrderBasket.read().length >= 20) { this.error.textContent = this.strings.cart_limit; return; }
    this.busy = true; this.button.disabled = true; this.form.inert = true; this.error.textContent = ''; this.querySelector('[data-submit-label]').textContent = this.strings.cart_added;
    try {
      this.syncPlacement();
      const properties = {};
      for (const [key, value] of new FormData(this.form)) if (key.startsWith('properties[') && typeof value === 'string' && value) properties[key.slice(11, -1)] = value;
      const item = {
        key: this.editKey || crypto.randomUUID(), hatStyle: this.hatStyle?.value || '', reuseArtwork: Boolean(this.reuseArtwork?.checked), placements: structuredClone(this.placements), handle: this.dataset.productHandle, productTitle: this.hatStyle?.value === 'Snapback' ? this.strings.snapback_title : this.dataset.productTitle,
        kind: this.dataset.kind, shirtType: this.shirtType?.value || this.retail.defaultProducts[this.dataset.kind] || '', size: this.sizeOption?.value || '',
        printSetup: this.printOption?.value || '', method: this.ink.length ? this.method : this.options[0].value,
        inkColors: this.method === 'screen' ? Number(this.inkCount?.value) : 0, hasFront: this.hasFront, hasBack: this.hasBack,
        color: this.querySelector('[data-shirt-color]:checked')?.value || properties['Preferred color'] || '', quantity: Number(this.qty.value),
        lineCents: this.lineCents, unitCents: this.unitCents, sideEnabled: Boolean(this.sideEnabled), sideMethod: this.sideMethod?.value || '', properties
      };
      item.artworkIdentity = await this.orderArtworkIdentity();
      item.artwork = await this.saveOrderArtwork();
      if (this.editKey) window.IzzOrderBasket.replace(item, this.originalEditItem);
      else window.IzzOrderBasket.add(item);
      location.assign(this.dataset.cartUrl);
    } catch (error) { this.error.textContent = error.message || this.strings.cart_failed; }
    finally { this.busy = false; this.form.inert = false; this.update(); }
  }
  taxCents(cents) {
    const rate = Math.round((this.retail?.shipping?.quoteTaxRate ?? 0.0875) * 1000000);
    return Math.floor((cents * rate + 500000) / 1000000);
  }
  updateOrderEstimate() {
    const estimate = this.shippingEstimate();
    const section = this.querySelector('[data-shipping-summary]');
    section.hidden = !estimate || this.lineCents == null;
    if (section.hidden) return;
    const tax = this.taxCents(this.lineCents);
    this.querySelector('[data-shipping-price]').textContent = estimate.cents == null ? this.strings.shipping_quote : this.money(estimate.cents);
    this.querySelector('[data-tax-price]').textContent = this.money(tax);
    this.querySelector('[data-order-estimate]').textContent = estimate.cents == null ? this.strings.shipping_quote : this.money(this.lineCents + tax + estimate.cents);
  }
  async openQuote() {
    if (this.busy || !this.qty.reportValidity() || !this.validateColor() || !this.validateArtwork() || !this.form.reportValidity()) return;
    const button = this.querySelector('[data-request-quote]');
    this.busy = true; button.disabled = true; this.error.textContent = '';
    try {
      this.syncPlacement();
      this.quoteArtwork = { primary: this.link.value.trim(), back: this.reuseArtwork?.checked ? this.link.value.trim() : this.backLink?.value.trim() || '' };
      if (this.file.files.length || (!this.backFile.disabled && this.backFile.files.length)) {
        const variant = this.variants.find(v => v.available && !v.options.includes('Screen printing'));
        if (!variant) throw new Error(this.strings.failed);
        const data = new FormData();
        data.set('id', String(variant.id)); data.set('quantity', '1');
        data.set('properties[_Artwork reference]', crypto.randomUUID());
        if (this.file.files.length) data.set('properties[Artwork]', this.file.files[0]);
        if (!this.backFile.disabled && this.backFile.files.length) data.set('properties[Back artwork]', this.backFile.files[0]);
        const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        const item = await response.json();
        if (!response.ok || item.status || !item.key) throw new Error(item.description || this.strings.failed);
        const cleanup = await fetch(this.dataset.cartUrl + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: 0 }) });
        if (!cleanup.ok) throw new Error(this.strings.quote_cleanup);
        if (this.file.files.length) this.quoteArtwork.primary = item.properties?.Artwork || '';
        if (!this.backFile.disabled && this.backFile.files.length) this.quoteArtwork.back = item.properties?.['Back artwork'] || '';
        if (this.reuseArtwork?.checked) this.quoteArtwork.back = this.quoteArtwork.primary;
        if ((this.file.files.length && !this.quoteArtwork.primary) || (!this.backFile.disabled && this.backFile.files.length && !this.quoteArtwork.back)) throw new Error(this.strings.failed);
      }
      const primary = this.quotePanel.querySelector('[data-quote-link]'); primary.value = this.quoteArtwork.primary;
      primary.readOnly = true;
      const back = this.quotePanel.querySelector('[data-quote-back-link]'); back.value = this.quoteArtwork.back;
      back.readOnly = true;
      back.required = this.hasFront && this.hasBack; back.disabled = !back.required; back.closest('label').hidden = !back.required;
      this.quotePanel.querySelector('[name="contact[Artwork permission]"]').checked = true;
      this.quotePanel.querySelector('[data-quote-artwork-ready]').textContent = this.strings.quote_saved;
      this.quotePanel.hidden = false; this.updateQuote();
      this.quotePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.quotePanel.querySelector('[name="contact[name]"]').focus({ preventScroll: true });
    } catch (error) { this.error.textContent = error.message || this.strings.failed; }
    finally { this.busy = false; button.disabled = false; }
  }
  disconnectedCallback() { this.placementObserver?.disconnect(); if (this.previewUrl) URL.revokeObjectURL(this.previewUrl); }
}
if (!customElements.get('izz-customizer')) customElements.define('izz-customizer', IzzCustomizer);












